import LiquidityAssetInfo from "./liquidity-asset-info";

export default LiquidityAssetInfo;
